import { render } from "./config.vue?vue&type=template&id=94c0a4e6&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"

import "./config.vue?vue&type=style&index=0&id=94c0a4e6&lang=scss&scoped=true"

import exportComponent from "/Users/helgeohltpng/Developer/js/triton/hoTriton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c0a4e6"]])

export default __exports__